import { createContext } from 'react';
const ExperimentContext = /*#__PURE__*/createContext({});
export default ExperimentContext;